import {search, getTotal, scroll, clearScrollId, init} from "@/plugins/elasticsearch";
import util from "@/mixins/util";


let searchAfterSort = [];
let allSearchCount = 0;
export default {
    data() {
        return {
            List: [],
            total: 0,
            page: 1,
            size: 10,
        }
    },
    methods: {
        initElastic(index='', type='') {
            if(util.isEmpty(index)) {
                return false;
            }
            let myIndex = index;
            let myType = type;
            if(util.isEmpty(myType)) {
                myType = '';
            }
            init(myIndex, myType);
            return true;
        },

        getTotal(body) {
            let elasticBody = body
            if(util.isEmpty(body)) {
                elasticBody = {query: {"match_all" : {}}};
            }
            return getTotal(elasticBody).then(res => {
                this.total = res.count;
                return res;
            });

        },

        getSearch(body) {
            let elasticBody = body;
            if(util.isEmpty(body)) {
                searchAfterSort = [];
                elasticBody = {
                    from : 0,
                    size: this.size,
                    query: {"match_all" : {}},
                };
            }
            return search(elasticBody).then(resp => {
                let list = [];
                if(resp.hasOwnProperty('hits')) {
                    resp.hits.hits.forEach(data => {
                        data._source._id = data._id;
                        list.push(data._source);
                    });
                    return list;
                }else{
                    return list;
                }

            });
        },

        getAllSearch(body, list=[]) {
            let elasticBody = body;
            if(util.isEmpty(body)) {
                searchAfterSort = [];
                elasticBody = {
                    query: {"match_all" : {}},
                    sort: [{'created_at': 'desc'}],
                };
            }
            return this.runScroll(body, null, list);
        },

        runScroll(body, id=null, list) {
            let getBody = JSON.parse(JSON.stringify(body));
            let scrollId = id;

            if(scrollId != null) {
                getBody = {_scroll_id: scrollId};
            }

            return scroll(getBody, 1000).then(resp => {
                resp.hits.hits.forEach((data, index) => {
                    data._source._id = data._id;
                    list.push(data._source);
                });

                if(resp.hasOwnProperty('_scroll_id') && resp._scroll_id) {
                    scrollId = resp._scroll_id;
                }

                if(list.length < resp.hits.total.value) {
                    return this.runScroll(body, scrollId, list);
                }else{
                    //return true;
                    //resolve(true);
                    return scrollId;
                }
            })
        },

        runClearScrollId(scrollId) {
            return clearScrollId(scrollId)
        }
    },
}
